import * as React from 'react';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import FormEditingHandler from 'Containers/FormEditingHandler';
import FilesList from './HistoryRowData';
import { useAppSelector } from 'Store/index';

const PatientFiles = (): React.JSX.Element => {
  const files = useAppSelector(s => s.documents.files) ?? [];

  return (
    <FormEditingHandler name="patientFiles" documents={[]}>
      {(): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader name={'patientFiles'} headerId={'patientFiles.title'} editButtons={<div />} />
          <FilesList files={files} />
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

export default PatientFiles;
